import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { FieldName, useWatch } from 'react-hook-form';

import { RegistrationFormOutputValues } from 'pages/Main/PackageListing/components/RegistrationForm/utils/validationSchema';

interface PropTypes {
  fieldName: FieldName<RegistrationFormOutputValues>;
  requirements: {
    title: string;
    regex: RegExp;
  }[];
}

function PasswordRequirements(props: PropTypes) {
  const password = useWatch({
    name: props.fieldName,
  });

  return (
    <List disablePadding>
      {props.requirements.map((item, index) => (
        <ListItem key={index}>
          <ListItemIcon>
            {item.regex.test(password) ? <CheckIcon color="success" /> : <CloseIcon color="error" />}
          </ListItemIcon>
          <ListItemText primary={item.title} />
        </ListItem>
      ))}
    </List>
  );
}

export default PasswordRequirements;
